// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2cX-Y","content":"RecentSearches_content__3xTiN"};